export const RandomizationAttributes = {
  sex: 'sex',
  donor_id: 'donor_id',
  dob: 'dob',
} as const;
export type RandomizationAttributes = (typeof RandomizationAttributes)[keyof typeof RandomizationAttributes];
